// components/marketplace/ProductGrid.tsx
"use client";

import ProductCard from "./ProductCard";

interface ProductGridProps {
  products: {
    id: number;
    name: string;
    slug: string;
    category: string;
    rating: number;
    imageUrl?: string;
    galleryUrls?: string[];
    provider: {
      id: number;
      name: string;
      role: "MANUFACTURER" | "DISTRIBUTOR" | "ADMIN" | string;
    };
  }[];
}

export default function ProductGrid({ products }: ProductGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
